export const validate = {
  email: (str) => {
    // ref: https://www.w3.org/TR/2012/WD-html-markup-20120329/input.email.html
    return !!str.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
  },
  domain: (str) => {
    // ref: https://regexr.com/3au3g
    return !!str.match(/(?:[a-z0-9](?:[a-z0-9-_]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g);
  },
  number: (str) => {
    return !!str.match(/[0-9]/g);
  }
}

// function to capitalize the string pro_Trial => Pro Trail
export const toCapitalize = str => str.replace(/(^|_)(\w)/g, ($0, $1, $2) => ($1 && ' ') + $2.toUpperCase());

export const isFreePlan = plan => plan && !plan.isTrial && !plan.isPaid;

export const getFirstTrialPlan = (plans) => plans.find(plan => plan.isTrial) || null;

export const showPicker = (e) => {
  try {
    // @ts-ignore
    return e?.target?.showPicker();
  } catch (error) {
    console.log('Failed to open calender picker', error);
  }
}

export const isDevMode = () => {
  return process.env.REACT_APP_ENV !== "production"
}